import { TimeLookbackRange } from "@shared/types";

import { calculateLookbackSeconds } from "../calculateLookbackSeconds";

export const timeLookbackRangeToSince = (
  timeLookbackRange: TimeLookbackRange
): number => {
  const trueSince = calculateLookbackSeconds(timeLookbackRange);
  // To prevent duplicated loading, decrease precision to be 100 seconds
  const roundedSince = Math.floor(trueSince / 100) * 100;

  return roundedSince;
};

export const timeLookbackRangeToSinceDate = (
  timeLookbackRange: TimeLookbackRange
): Date => {
  return new Date(timeLookbackRangeToSince(timeLookbackRange) * 1000);
};
